/**
 * Get the normalized event key across all browsers
 * @param event keyboard event
 */
export function normalizeEventKey(event) {
  var key = event.key,
      keyCode = event.keyCode;
  var isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
  var eventKey = isArrowKey ? "Arrow" + key : key;
  return eventKey;
}
export function getRelatedTarget(event) {
  return event.relatedTarget || event.nativeEvent.explicitOriginalTarget || document.activeElement;
}
export var isRightClick = function isRightClick(event) {
  return event.button !== 0;
};